import { Component, Injector, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { AfAuctionModel } from "@pattonair/auction-framework";
import { MfBaseComponent, mfStringIsEmptyOrWhitespace, MfTypeInfo, mfTypeIsUndefined } from "@pattonair/material-framework";
import { concatMap, from, of, toArray } from "rxjs";
import { AucRouteNames } from "../route.names";
import { AucAuctionService } from "../services/auction.service";

const TYPE_INFO: MfTypeInfo = { className: "AucAuctionListComponent" };

@Component({
  selector: "ecom-auction-list",
  templateUrl: "./auction.list.component.html",
  styleUrls: ["./auction.list.component.scss"]
})
export class AucAuctionListComponent extends MfBaseComponent implements OnDestroy {

  protected _auctions: AfAuctionModel[] = [];

  public constructor(
    protected override _injector: Injector,
    protected _auctionService: AucAuctionService,
    protected _router: Router,
  ) {
    super(TYPE_INFO, _injector);
    this._getLiveAuctions();
  }

  public override ngOnDestroy(): void {
    this._sub(from(this._auctions).pipe(
      concatMap(auction => {
        if (mfTypeIsUndefined(auction) || mfStringIsEmptyOrWhitespace(auction.id)) {
          return of();
        } else {
          return this._auctionService.unsubscribeFromAuction(auction.id);
        }
      }),
      toArray(),
    ), {
      next: () => {
        this._sub(this._auctionService.stopConnection());
      },
    });

    super.ngOnDestroy();
  }

  protected _getLiveAuctions(): void {
    const loading = this._subLoading(this._auctionService.getAllLive(), {
      next: (auctions) => {
        this._auctions = auctions;
        this._subscribeToChanges();
        loading.complete();
      },
      error: () => {
        loading.complete();
      },
    });
  }

  protected _goToDetail(auction: AfAuctionModel): void {
    if (!mfTypeIsUndefined(auction) && !mfTypeIsUndefined(auction.id)) {
      this._router.navigate([AucRouteNames.getAuctionDetailRouteAuctionId(auction.id)]);
    }
  }

  protected _subscribeToChanges(): void {
    this._sub(this._auctionService.startConnection(), {
      next: () => {
        this._sub(from(this._auctions).pipe(
          concatMap(auction => {
            if (!mfTypeIsUndefined(auction) && !mfStringIsEmptyOrWhitespace(auction.id)) {
              this._sub(this._auctionService.subscribeToAuction(auction.id), {
                next: () => {
                  this._sub(this._auctionService.auctionUpdated, {
                    next: (message) => {
                      if (mfTypeIsUndefined(auction) || mfStringIsEmptyOrWhitespace(auction.id) || auction.id !== message.id) {
                        return;
                      }
                      auction.currentPrice = message.currentPrice;
                      auction.bidCount = message.bidCount;
                      auction.reservePriceMet = message.isReservePriceMet;
                      auction.status = message.auctionStatus;
                    },
                  });
                },
              });
            }
            return of();
          })
        ));
      }
    });
  }
}
